import {
  COMPCARDS_LOADING,
  COMPCARDS_LOADED,
  COMPCARDS_ERROR,
  COMPCARDS_RESET,
  SET_CURRENT_COMPCARD,
  CLEAR_CURRENT_COMPCARD,
} from "../types";

//eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case COMPCARDS_RESET:
      return {
        ...state,
        ...action.payload,
      };
    case COMPCARDS_LOADING:
      return {
        ...state,
        compCardsLoading: true,
        compCardsLoaded: false,
        error: null,
      };
    case COMPCARDS_LOADED:
      return {
        ...state,
        compCards: action.payload,
        compCardsLoading: false,
        compCardsLoaded: true,
        changedCompCards: [],
      };
    case COMPCARDS_ERROR:
      return {
        ...state,
        error: action.payload,
        compCardsLoading: false,
        compCardsLoaded: false,
      };
    case SET_CURRENT_COMPCARD:
      return { ...state, selectedCompCard: action.payload.compCard };
    case CLEAR_CURRENT_COMPCARD:
      return { ...state, selectedCompCard: null };
    default:
      return state;
  }
};
